let baseUrl = 'https://www.bcpai.com/rest-web'

if(window.location.host){
    if(window.location.host.indexOf('test')> -1){
        baseUrl = 'http://www.bcpai.test/rest-web'
    }else if(window.location.host.indexOf('green')> -1){
        baseUrl = 'http://www.bcpai.green/rest-web'
    }else{
        baseUrl = 'https://www.bcpai.com/rest-web'
    }
}
export default baseUrl
